import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import formatPrice from "@/core/helpers/formatPrice";
import { Info2Icon, Star3Icon } from "@/shared/icons";
import { Tooltip } from "@/shared/ui";
import FactionTooltipContent from "@/domains/faction/components/FactionTooltipContent";

type Props = {
  title: string;
  description: string;
  count: number;
  days: number;
  dataMzAccent: string;
  Icon?: (props: { className?: string }) => JSX.Element;
  isRuble?: boolean;
  className?: string;
};

export default function FactionInfoBlock({
  title,
  description,
  count,
  days,
  dataMzAccent,
  Icon = Star3Icon,
  isRuble,
  className,
}: Props) {
  const { t } = useTranslation("faction");

  const tooltipContent = (
    <FactionTooltipContent title={title} description={description} className="rounded-bl-none" />
  );

  return (
    <div className={cn("p-4 bg-dark-800 rounded-xl", className)}>
      <div className="flex items-center mb-5">
        <Icon className="size-4.5 text-[#B8B8B8]" />
        <p className="ml-2 text-12 font-bold uppercase leading-none">{title}</p>
        <Tooltip
          content={tooltipContent}
          className="z-2 ml-auto"
          tooltipClassName="bottom-2 left-6"
        >
          <Info2Icon className="size-4.5 text-white/30 transition-all duration-200 hover:text-white" />
        </Tooltip>
      </div>
      <div className="flex items-center">
        <p className="text-18 font-bold leading-none">
          {formatPrice(count)} {isRuble && "₽"}
        </p>
        <p className="flex justify-center items-center ml-auto py-1.5 px-[0.4375rem] text-11 font-bold bg-white/6 rounded-[0.3125rem]">
          {days}д.
        </p>
        <p
          className={cn(
            "flex justify-center items-center ml-1.5 py-1.5 px-[0.4375rem] text-11 font-bold uppercase rounded-[0.3125rem]",
            `bg-gradient-${dataMzAccent}`,
          )}
        >
          Всего
        </p>
      </div>
    </div>
  );
}
